import * as React from "react";
import Home from "../components/home/Home";
import Contact from "../components/contact/Contact";
import { Helmet } from "react-helmet";
import Footer from "../components/footer/Footer";
import "./index.scss";

const IndexPage = () => {
  return (
    <>
      <Helmet htmlAttributes={{ lang: "en" }}>
        <title>Software Development Company | Adeptech</title>
        <meta
          name="description"
          content="Adeptech a software company that is experienced in creating Web Applications, Android Applications, IOS Applications."
        />
        <meta
          name="keyword"
          content="software, software developers, custom software development company, nearshore software development company, offshore software development company, healthcare software development company, best software development company, top software development company, software development company around me, enterprise software development company, software development company in pakistan, software development company in india, software development company in usa, Adeptech, Software Development Company, Web Developers, Android App Developers, IOS Developers, IOS App Developers, Software Developers in US UK, Adeptech.io, custom software development company"
        />
        <meta name="author" content="Adeptech" />
      </Helmet>
      <Home />
      <section id="contactus">
        <Contact divider={true} calendly={true} />
      </section>
      <Footer />
    </>
  );
};

export default IndexPage;

